/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export default class DropZonesOverlayStateAPI {
	/**
	 * @function DropZonesOverlayStateAPI#getModel
	 * @description get the instance of OverlayModel
	 * @return {OverlayModel} the instance of OverlayModel
	 */
	getModel() {}

	/**
	 * @function DropZonesOverlayStateAPI#show
	 * @description show the overlay drop zones after it is being mounted
	 */
	show() {}

	/**
	 * @function DropZonesOverlayStateAPI#show
	 * @description hide the overlay drop zones after it is being mounted
	 */
	hide() {}
}


// WEBPACK FOOTER //
// ./src/js/dashboard/DropZonesOverlayStateAPI.js